import client from "@/lib/api";

// Server-sent popups (Web Push): work even when the DreamCRM tab is asleep or closed.
const FLAG = "dreamcrm_push_endpoint";

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const pushOnHere = () => !!localStorage.getItem(FLAG);

const toBytes = (b64) => {
  const raw = atob((b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

async function registration() {
  if (!(await navigator.serviceWorker.getRegistration())) await navigator.serviceWorker.register("/sw.js");
  return navigator.serviceWorker.ready;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("This browser doesn't support popups");
  if ((await Notification.requestPermission()) !== "granted") throw new Error("Notifications are blocked for this site in your browser settings");
  const reg = await registration();
  const { data } = await client.get("/push/config");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.public_key) });
  await client.post("/push/subscription", sub.toJSON());
  localStorage.setItem(FLAG, sub.endpoint);
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  const endpoint = sub?.endpoint || localStorage.getItem(FLAG);
  if (endpoint) await client.delete("/push/subscription", { params: { endpoint } }).catch(() => {});
  await sub?.unsubscribe().catch(() => {});
  localStorage.removeItem(FLAG);
}

// Re-save the subscription after login (browser may have rotated it, or a different user signed in).
export async function refreshPush() {
  if (!pushSupported() || !pushOnHere() || Notification.permission !== "granted") return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  if (!sub) { localStorage.removeItem(FLAG); return; }
  await client.post("/push/subscription", sub.toJSON()).catch(() => {});
  localStorage.setItem(FLAG, sub.endpoint);
}
